import * as React from 'react';
import { SelectWhenScroll } from '../SelectWhenScroll';

interface BlockTypeSelectorProps {
    value: 'SMART_BLOCK' | 'INTERPRETATION_BLOCK';
    onChange: (value: 'SMART_BLOCK' | 'INTERPRETATION_BLOCK') => void;
    disabled: boolean;
}

const BLOCK_TYPES = [
    { label: 'Smart Block', value: 'SMART_BLOCK' },
    { label: 'Interpretation Block', value: 'INTERPRETATION_BLOCK' }
];

const BlockTypeSelector: React.FC<BlockTypeSelectorProps> = ({ value, onChange, disabled }) => {
    return (
        <div className="custom-block-field">
            <label className="custom-block-label">Type</label>
            <SelectWhenScroll
                value={value}
                onChange={onChange}
                options={BLOCK_TYPES}
                disabled={disabled}
                style={{ width: '100%' }}
            />
        </div>
    );
};

export default BlockTypeSelector;
